export default __webpack_public_path__ + "static/media/placeholder_img.8e175a4c.webp";